import React from "react";

interface Props {
  labelText: string;
  clickHandler?: () => void;
  buttonEnabled: boolean;
}

const stylesSelected = {
  backgroundColor: "#4e342e",
  color: "#ffffff",
  border: '1px solid #4e342e',
  borderRadius: '6px',
  boxShadow: 'none',
  padding: "8px",
  textDecoration: "bold",
  display: "inline-block",
  fontSize: "16px",
  outline: 'none'
}

const stylesNotSelected = {
  backgroundColor: "#ffffff",
  color: "#000000",
  border: '1px solid #4e342e',
  borderRadius: '6px',
  boxShadow: 'none',
  padding: "8px",
  textDecoration: "bold",
  display: "inline-block",
  fontSize: "16px",
  outline: 'none'
}


const SecondaryButton: React.FC<Props> = ({ labelText, clickHandler, buttonEnabled }) => {
  return (
    <button className="main-btn" disabled={!buttonEnabled} style={buttonEnabled ? stylesSelected : stylesNotSelected} onClick={clickHandler}>{labelText}</button>
  );
};

export default SecondaryButton;
